import { rem } from "@certn/cascadia";
import { Illustration, Text, Card } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { ActiveComplete } from "../../types";

type TasksEmptyStateProps = {
  isSearching: boolean;
  tab: ActiveComplete;
};
export function TasksEmptyState(props: TasksEmptyStateProps) {
  const { isSearching, tab } = props;
  const { t } = useTranslation();

  return (
    <>
      <Card type="large" border="border-base" className={css(styles.card)}>
        <Illustration name={isSearching ? "no-results" : "check-success"} />
        <Text style="global/body-secondary" align="center" color="text-weak">
          {isSearching && t("No results found.")}
          {!isSearching && (
            <>
              {tab === "ACTIVE" && t("You're all caught up")}
              {tab === "COMPLETE" &&
                t("Tasks marked as done will appear here.")}
            </>
          )}
        </Text>
      </Card>
    </>
  );
}

const styles = {
  card: css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: rem("space-6"),
    gap: rem("space-4"),
  }),
};
